import React from 'react'

import { Form, Col } from '_zari/core'

const AnioDocumentoFormGroup = ({ value, onChange }) => {
  const currentYear = React.useMemo(() => {
    return new Date().getFullYear()
  }, [])

  const selectOpions = React.useMemo(() => {
    const salida = []
    for (let i = currentYear; i >= 2000; i--) {
      salida.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }

    return salida
  }, [currentYear])

  return (
    <Form.Group>
      <Form.Label text='AÑO DOCUMENTO' htmlFor='input-anioDocumento' md={4} />
      <Col md={8}>
        <Form.Select value={value} onChange={onChange} id='input-anioDocumento'>
          <option value=''>Seleccionar</option>
          {selectOpions}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default AnioDocumentoFormGroup
